export const montarMetadadosDominioGeral = (dominioLista = {}) => {
  const itens = dominioLista?.itens || [];
  const metadadosDominioLista = dominioLista?.metadadosDominioLista || [];

  return itens.map((dominioGeral) => {
    const metadadosGeral = metadadosDominioLista.map((mdl) => {
      const existente = dominioGeral?.metadadosDominioGeral?.find(
        (md) => md?.metadadoDominioLista?.id === mdl?.id
      );

      const valorAtributo = mdl?.tipoAtributo === "LG"
        ? (existente?.valorAtributo === true || existente?.valorAtributo === "true" ? "true" : "false")
        : existente?.valorAtributo ?? "";

      return {
        id: existente?.id,
        metadadoDominioLista: mdl,
        dominioGeral: { id: dominioGeral?.id },
        valorAtributo
      };
    });

    return {
      ...dominioGeral,
      metadadosDominioGeral: metadadosGeral
    };
  });
};
